/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

  $(document).ready(function() {
    $('body').on('click', '[name="checkout"]', function() {
      if ($('#agree-zustand').is(':checked') && $('#agree-frist').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("Sie müssen die Bedingungen akzeptieren, um zur Kasse zu gelangen.");
        return false;
      }
    });
  });